import { SkeletonLoader } from '@payaca/ambrosia';
import { FC } from 'react';

const KeyIndicatorTile: FC = () => (
  <div className="border rounded-lg p-4 flex flex-col gap-2">
    <SkeletonLoader.Text className="h-3 w-28" />
    <SkeletonLoader className="h-8 w-32 rounded" />
    <SkeletonLoader.Text className="h-3 w-20" />
  </div>
);

const ChartPanel: FC = () => (
  <div className="border rounded-lg p-4 flex flex-col gap-3">
    <SkeletonLoader.Text className="h-5 w-32" />
    <SkeletonLoader className="h-48 w-full rounded" />
  </div>
);

const AnalyticsPageSkeleton: FC = () => (
  <div className="mx-auto max-w-screen-2xl space-y-6 px-4 py-6 md:px-8">
    <div className="flex items-end gap-6 border-b pb-2">
      <SkeletonLoader.Text className="h-5 w-28" />
      <SkeletonLoader.Text className="h-5 w-28" />
    </div>

    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      <KeyIndicatorTile />
      <KeyIndicatorTile />
      <KeyIndicatorTile />
    </div>

    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <ChartPanel />
      <ChartPanel />
      <ChartPanel />
      <ChartPanel />
    </div>
  </div>
);

export default AnalyticsPageSkeleton;
